export const HELP_CENTER_HOME_URL = 'https://ajuda.cakto.com.br/pt/';

// Canal de suporte de quem nao e produtor (comprador/aluno). O chat da Gleap e exclusivo
// do produtor logado no app, entao o resto do publico cai na central de ajuda.
export const HELP_CENTER_SUPPORT_URL = 'https://ajuda.cakto.com.br/';

export const HELP_CENTER_ARTICLES = {
  threeDs:
    'https://ajuda.cakto.com.br/pt-br/articles/43-o-que-e-3ds-e-como-ele-aumenta-a-seguranca-das-suas-vendas-online',
  caktoMcp:
    'https://ajuda.cakto.com.br/pt-br/articles/159-como-conectar-o-chatgpt-o-claude-ou-o-codex-a-sua-conta-cakto',
  disableProductCheckout:
    'https://ajuda.cakto.com.br/pt-br/articles/64-como-encerrar-as-vendas-e-desabilitar-o-checkout-de-um-produto',
  awards:
    'https://ajuda.cakto.com.br/pt-br/articles/89-premiacoes-cakto-conheca-os-niveis-e-como-resgatar-os-seus-premios',
  pagaleve:
    'https://ajuda.cakto.com.br/pt-br/articles/142-como-funciona-o-pix-4x-sem-juros-com-a-pagaleve',
  whatsappCartRecovery:
    'https://ajuda.cakto.com.br/pt-br/articles/154-como-funciona-a-recuperacao-de-carrinho-por-whatsapp',
  whatsappDeliveryMessage:
    'https://ajuda.cakto.com.br/pt-br/articles/155-como-funciona-a-entrega-do-produto-pelo-whatsapp',
  whatsappSubscriptionOverdue:
    'https://ajuda.cakto.com.br/pt-br/articles/156-como-funciona-a-cobranca-de-assinatura-vencida-pelo-whatsapp',
  affiliateProgram:
    'https://ajuda.cakto.com.br/pt-br/articles/125-como-habilitar-e-configurar-o-programa-de-afiliados-na-cakto',
};

export const HELP_CENTER_COLLECTIONS = {
  whatsapp: 'https://ajuda.cakto.com.br/pt-br/collections/12-whatsapp',
};

export const EXCHANGE_RATES_INFO_URL_DEFAULT = 'https://ajuda.cakto.com.br/pt-br/articles/72-quais-sao-as-taxas-da-plataforma-cakto';
